import React from 'react';

export default Component => (
  class withItemSearch extends React.Component {
    constructor() {
      super();

      this.state = {
        search: '',
      };
    }

    componentWillUnmount() {
      this.props.onBlur();
    }

    onSearch = (event) => {
      this.setState({ search: event.target.value });
    };

    render() {
      const { search } = this.state;
      const { items, isItemChecked, ...rest } = this.props;
      const lowerCaseSearch = search.toLowerCase();
      const filteredItems = items.filter(
        ({ name, value }) => (
          name.toLowerCase().includes(lowerCaseSearch)
          || (value.split('__')[1] || '').toLowerCase() === lowerCaseSearch
        ),
      );

      return (
        <Component
          {...rest}
          groups={filteredItems.length === 0
            ? []
            : [{
              id: '',
              items: filteredItems
                .map(item => ({
                  ...item,
                  icon: {
                    name: isItemChecked(item) ? 'checkmark' : 'empty',
                    color: 'blue',
                  },
                })),
            }]
          }
          search={search}
          onSearch={this.onSearch}
        />
      );
    }
  }
);
